export const aciBuilding = {
    iconName: 'building',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M18.706 22c-.353 0-.588-.235-.588-.588V4.942c0-.236.235-.589.588-.589s.588.353.588.588v16.47c0 .354-.235.589-.588.589z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M18.588 5.53H4.706c-.235 0-.588-.236-.588-.589s.353-.588.588-.588H18.47c.353 0 .588.235.588.588s-.235.588-.47.588z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M4.588 22C4.235 22 4 21.765 4 21.412V4.942c0-.236.235-.589.588-.589s.588.353.588.588v16.47c0 .354-.235.589-.588.589z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M18.706 5.53H4.588c-.235 0-.353-.118-.47-.236-.118-.235-.118-.47 0-.588l1.294-2.353c0-.235.235-.353.47-.353h11.53c.235 0 .47.118.47.353l1.294 2.353c.118.235.118.353 0 .588-.117.118-.235.235-.47.235zM5.529 4.352h12.118l-.588-1.177H6.235L5.53 4.353zM18.706 22H4.588C4.235 22 4 21.765 4 21.412s.235-.588.588-.588h14.118c.353 0 .588.235.588.588s-.235.588-.588.588z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M14 22H9.294c-.353 0-.588-.235-.588-.588v-2.353a2.913 2.913 0 012.941-2.941 2.913 2.913 0 012.941 2.94v2.354c0 .353-.235.588-.588.588zm-4.117-1.176h3.529v-1.765c0-.941-.824-1.765-1.765-1.765-.94 0-1.764.824-1.764 1.765v1.765zM11.647 8.353a.941.941 0 100-1.883.941.941 0 000 1.883zM15.412 8.353a.941.941 0 100-1.883.941.941 0 000 1.883zM7.883 8.353a.941.941 0 100-1.883.941.941 0 000 1.883zM11.647 11.882a.941.941 0 100-1.882.941.941 0 000 1.882zM15.412 11.882a.941.941 0 100-1.882.941.941 0 000 1.882zM7.883 11.882a.941.941 0 100-1.882.941.941 0 000 1.882zM11.647 15.53a.941.941 0 100-1.883.941.941 0 000 1.882zM15.412 15.53a.941.941 0 100-1.883.941.941 0 000 1.882zM7.883 15.53a.941.941 0 100-1.883.941.941 0 000 1.882z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
